import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = { class: "q-gutter-sm" }

import { useModelWrapper } from './helpers/useModelWrapper'

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

/**
 * This base modal wrapper contains stylings to be applied to modals throughout
 * the app. Takes title, content, and actions slots. Required modelValue
 * (use v-model="someRef") to cascade visibility down to the dialog
 * component.
 */
const props = __props
const emit = __emit

const value = useModelWrapper(props, emit)

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    modelValue: _unref(value),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "q-pa-md",
        style: {"min-width":"24rem"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "title")
              ])
            ]),
            _: 3
          }),
          _createVNode(_component_q_card_section, { class: "q-mb-md" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "content")
            ]),
            _: 3
          }),
          _createVNode(_component_q_card_actions, {
            align: "right",
            class: "no-padding"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "actions")
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["modelValue"]))
}
}

})